import { timelineStory } from '@/mocks/blackinfo';

export default function Timeline() {
  return (
    <section id="timeline" className="mx-auto max-w-[1280px] px-4 pt-12 md:px-6 md:pt-16">
      <div className="overflow-hidden rounded-lg border border-stone-200 bg-stone-950 text-white">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* 事件概述 */}
          <div className="flex flex-col p-6 md:p-9">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded bg-red-600 px-2.5 py-1 text-xs font-bold">
                <i className="ri-time-zone-line" /> {timelineStory.tag}
              </span>
              <span className="rounded-full border border-white/20 px-2.5 py-1 text-[11px] font-medium text-white/70">
                {timelineStory.status}
              </span>
            </div>
            <h2 className="mt-4 font-display text-xl font-bold leading-snug md:text-2xl">{timelineStory.title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-white/70">{timelineStory.summary}</p>

            <div className="mt-6 border-t border-white/10 pt-5">
              <p className="text-xs font-semibold tracking-wide text-white/40">看点</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {['真实库存存疑', '口径前后不一', '退款通道是否顺畅'].map((p) => (
                  <span
                    key={p}
                    className="rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs text-white/75"
                  >
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* 时间线 */}
          <div className="bg-white px-6 py-8 text-stone-900 md:px-9">
            <div className="relative ml-1 flex flex-col gap-7 border-l border-stone-200 pl-6">
              {timelineStory.items.map((it, idx) => (
                <div key={idx} className="relative">
                  <span className="absolute -left-[31px] top-1 h-3 w-3 rounded-full border-2 border-red-600 bg-white" />
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded bg-stone-900 px-2 py-0.5 text-[11px] font-bold text-white">{it.time}</span>
                    <span className="text-[11px] text-stone-400">节点 {idx + 1}/4</span>
                  </div>
                  <h3 className="mt-2 font-display text-base font-bold leading-snug md:text-lg">{it.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-stone-500">{it.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}